import Menu, { MenuProps } from '@mui/material/Menu';
import React from 'react';
import type { SecuredComponentBaseProps } from '../../types';
import { useSecurity } from '../hooks/useSecurity';

type SecuredMenuProps = MenuProps & Omit<SecuredComponentBaseProps, 'fallback' | 'securityEnforcementMode'>;

export default function SecuredMenu({
    securityAction,
    securityTarget,
    open,
    children,
    ...menuProps
}: SecuredMenuProps) {
    const decision = useSecurity(securityAction, securityTarget);
    const isAllowed = !decision.pending && decision.allowed;
    const isSecurelyOpen = isAllowed && open;

    return (
        <Menu {...menuProps} open={isSecurelyOpen}>
            {children}
        </Menu>
    );
}
